export function normalizeI18nKey(key) {
    return key.toLowerCase().trim();
}
//# sourceMappingURL=util.js.map